import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AutomaticPaymentRemindersRowsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S16};
  padding: ${Spacing.S16};
  border: 1px solid ${Color.Grey150};
  border-radius: ${DefaultValue.BorderRadius};
`
